<template>
  <div class="main">
    <div v-show="loading" class='loader'>
      <div class='loader-gif'>
        <img src="../assets/loading.gif" alt="" class="img">
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Toast} from 'vant';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

Vue.use(Toast);

import {getMiniPath} from '../api/mini'

export default {
  name: 'index',
  data() {
    return {
      loading: false
    };
  },
  mounted() {
    const encipheredData = this.$route.query.encipheredData
    console.log('---encipheredData-----', encipheredData)
    if (encipheredData) {
      this.fetchMiniPath(encipheredData)
    } else {
      Toast('无效参数')
    }
  },
  methods: {
    async fetchMiniPath(encipheredData) {
      this.loading = true
      const visitorId = await this.getVisitorId()
      let params = {
        deviceCode: visitorId,
        encipheredData: decodeURIComponent(encipheredData)
      }
      getMiniPath(params).then(res => {
        console.log(res)
        setTimeout(() => {
          this.loading = false
        }, 2000)
        if (res.status === 200 && res.data.errcode === 0) {
          window.location.href = res.data.url_link
        } else {
          Toast(res.data.errmsg)
        }
      })
    },
    async getVisitorId() {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      return result.visitorId;
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  top: 0;
  font-size: 36/10vw;
  display: flex;
  flex-direction: column;

  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }

  .loader-gif {
    .img {
      width: 50vw;
    }
  }

}

</style>
